var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../../store';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { MilesSliderControlComponent } from './miles-slider-control.component';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { ScreenService, ModalService, SidebarService } from '@ibe/services/ui';
import { INDRAMilesService } from '@ibe.services/miles.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import { UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
var INDRAMilesSliderControlComponent = /** @class */ (function (_super) {
    __extends(INDRAMilesSliderControlComponent, _super);
    function INDRAMilesSliderControlComponent(modalService, screen, store, sidebarService, cd, milesService, currencyService, paymentInfoService, router, ibeAdminConfigService) {
        var _this = _super.call(this) || this;
        _this.modalService = modalService;
        _this.screen = screen;
        _this.store = store;
        _this.sidebarService = sidebarService;
        _this.cd = cd;
        _this.milesService = milesService;
        _this.currencyService = currencyService;
        _this.paymentInfoService = paymentInfoService;
        _this.router = router;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.variation = null;
        _this.userInfo$ = _this.store.select(fromStore.getUserInfo);
        _this.hasLogin = false;
        _this.userMiles = null;
        _this.isUserMGPClient = false;
        _this.maxIndicator = { cash: 0, miles: 0 };
        _this.showMaxIndicatorCash = false;
        _this.maxStep = { cash: 0, miles: 0 };
        _this.minStep = 0;
        _this.dummySteps = 3;
        _this.flightWithMiles$ = _this.store.select(fromStore.getFlightsFilterFlightWithMiles);
        _this.bookedTripDiscounts$ = _this.store.select(fromStore.getSelectedBookedTripDiscounts);
        _this.bookedTripDiscounts = [];
        _this.milesDiscount$ = _this.store.select(fromStore.getMilesBarDiscountInformationMiles);
        _this.hasPromo = false;
        _this.promoMiles = { value: 0, discount: 0 };
        _this.formRange = new FormGroup({ sliderControl: new FormControl(null) });
        _this.stepJump = 0;
        _this.availableSteps = []; // Desktop slider
        _this.milesOptions = []; // Mobile selectbox
        _this.milesInFlightDiscount$ = _this.store.select(fromStore.getMilesInFlightDiscount);
        _this.ancillaryTotalToPay$ = _this.store.select(fromStore.getAncillaryTotalToPay);
        _this.hasChanges$ = combineLatest([_this.userInfo$, _this.ancillaryTotalToPay$, _this.milesService.conversionRates$]);
        _this.timeToThink_to_booking$ = _this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
        _this.isTTTBookingPayment = false;
        _this.isMobile = false;
        _this.isIE = false || !!document['documentMode'];
        _this.isAlive = true;
        _this.isLoading = true;
        _this.hasRates = false;
        _this.disabledSlider = false;
        _this.disabledSlider$ = _this.store.select(fromStore.getAncillaryToPayWithMilesLoading);
        _this.previousSliderValue = 0;
        _this.triggerUseMiles$ = _this.milesService.triggerUseMiles$;
        _this.currency = _this.currencyService.INDRA_getCurrencySymbol().unit;
        _this.INDRA_getMilesAllowance();
        _this.screen.isMobile().subscribe(function (value) {
            _this.isMobile = value;
        });
        _this.bookedTripDiscounts$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (discounts) {
            _this.bookedTripDiscounts = Object.assign([], discounts);
        });
        _this.flightWithMiles$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (flightWithMiles) {
            _this.flightWithMiles = flightWithMiles;
        });
        _this.milesDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value.cash && value.miles) {
                _this.promoMiles.discount = value.cash;
                _this.promoMiles.value = value.miles;
                _this.hasPromo = true;
            }
            else {
                _this.hasPromo = false;
            }
        });
        _this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var userInfo = _a[0], ancillaryTotalToPay = _a[1];
            if (userInfo) {
                _this.hasLogin = true;
                _this.userMiles = userInfo['currentPoints'] ? userInfo['currentPoints'] : 0;
                _this.isUserMGPClient = userInfo['ffLevel'] ? true : false;
                _this.maxIndicator.miles = ancillaryTotalToPay ? _this.userMiles - ancillaryTotalToPay.miles : _this.userMiles;
                _this.showMaxIndicatorCash = false;
                if (_this.INDRA_isTesteSetMilesPoint()) {
                    if (_this.availableSteps && _this.availableSteps.length) {
                        _this.INDRA_setSliderControlToMax();
                    }
                }
                else {
                    _this.INDRA_updateMiles(true);
                }
            }
            else {
                _this.hasLogin = false;
                _this.isUserMGPClient = false;
            }
            _this.INDRA_generateValues();
            if (_this.INDRA_isTesteSetMilesPoint()) {
                if (_this.availableSteps && _this.availableSteps.length) {
                    _this.INDRA_setSliderControlToMax();
                }
            }
        });
        _this.milesInFlightDiscount$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                if (_this.INDRA_isTesteSetMilesPoint()) {
                    _this.INDRA_setSliderControlToMax();
                }
                else {
                    _this.milesInFlightDiscount = value;
                    var initialDiscount = _this.availableSteps.find(function (step) { return step.value === value.miles; });
                    _this.formRange.controls['sliderControl'].setValue(initialDiscount ? initialDiscount.value : _this.INDRA_getLeastStepMiles());
                }
            }
            else {
                _this.formRange.controls['sliderControl'].setValue(0);
                _this.INDRA_updateMiles(true);
            }
        });
        _this.disabledSlider$.pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.disabledSlider = value;
            _this.cd.markForCheck();
        });
        // get booking total cost
        _this.paymentInfoService.totalFlightPrice
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (totalFlightPrice) {
            _this.totalFlightPrice = totalFlightPrice;
        });
        /*
        // TODO implement this with actual logic (from sprint 8 merge) -- this is used supposedly to set the slider to the
        // 'saved' initial mgp discount when TTT for the booking was availed previously
        this.timeToThink_to_booking$.pipe(takeWhile(() => this.isAlive))
            .subscribe(value => {
                if (value) {
                    this.isTTTBookingPayment = true;
                    this.formRange.controls['sliderControl'].setValue(this.promoMiles.value);
                    this.milesSelected = this.promoMiles.value;
                    this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction(this.milesSelected));
                }
            });
        */
        _this.triggerUseMiles$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                if (_this.hasPromo) {
                    if (!(_this.hasLogin && _this.userMiles < _this.promoMiles.value)) {
                        _this.INDRA_updateMiles();
                    }
                }
            }
        });
        return _this;
    }
    INDRAMilesSliderControlComponent.prototype.ngOnInit = function () {
        var _this = this;
        clearTimeout(this.loadingTimeout); // to prevent style issues
        this.loadingTimeout = setTimeout(function () {
            _this.isLoading = false;
        }, 500);
    };
    INDRAMilesSliderControlComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    // ----------------------- START SLIDER PROCESSES -------------------------------//
    INDRAMilesSliderControlComponent.prototype.INDRA_generateValues = function () {
        var _this = this;
        this.milesOptions = [{ value: 0, label: "0 M | " + this.currencyService.INDRA_formatCash(0) + " " + this.currency }];
        this.availableSteps = [{ value: 0, discount: '0' }];
        if (this.hasPromo && ((this.hasLogin && this.isUserMGPClient && this.maxIndicator.miles >= this.minStep) || (!this.hasLogin))) {
            this.milesOptions.push({ value: this.promoMiles.value, label: 'Promo ' + this.promoMiles.value + ' M | ' + this.currencyService.INDRA_formatCash(this.promoMiles.discount) + ' ' + this.currency });
            this.availableSteps.push({ value: this.promoMiles.value, discount: this.promoMiles.discount, legend: '' });
            if (this.hasLogin) {
                this.minStep = this.promoMiles.value;
                this.initialAvailableSteps = this.availableSteps;
                if (this.userMiles < this.minStep) {
                    var deficitMiles = this.minStep - this.userMiles;
                    if (deficitMiles <= this.milesAllowance) {
                        this.formRange.controls['sliderControl'].setValue(this.minStep);
                    }
                    else {
                        this.formRange.controls['sliderControl'].setValue(0);
                        this.INDRA_updateMiles();
                    }
                }
            }
            else {
                this.minStep = 0;
            }
        }
        this.hasRates = false;
        var conversionRates = this.milesService.conversionRates;
        conversionRates.forEach(function (rate) {
            if (rate.valueCash) {
                if (_this.hasLogin && _this.isUserMGPClient && rate.miles > _this.promoMiles.value) {
                    _this.hasRates = true;
                    _this.milesOptions.push({ value: rate.miles, label: rate.miles + ' M | ' + _this.currencyService.INDRA_formatCash(rate.valueCash) + ' ' + _this.currency });
                    _this.availableSteps.push({ value: rate.miles, discount: rate.valueCash });
                }
            }
        });
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_getDiscountValue = function (cash) {
        return this.hasPromo ? cash + this.promoMiles.discount : cash;
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_getMilesAllowance = function () {
        var milesAllowanceConfig = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.initialMilesAllowance');
        this.milesAllowance = milesAllowanceConfig && !isNaN(parseFloat(milesAllowanceConfig)) ? Number(milesAllowanceConfig) : 1800;
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_hasMilesAllowance = function (userMiles, minStep) {
        if (this.bookAwardFlights) {
            return (userMiles < minStep);
        }
        else {
            if (userMiles >= 0) {
                if (userMiles < minStep) {
                    var deficitMiles = minStep - userMiles;
                    if (deficitMiles <= this.milesAllowance) {
                        this.userMiles = this.milesAllowance;
                        this.availableSteps = this.initialAvailableSteps;
                        this.formRange.controls['sliderControl'].setValue(this.milesInFlightDiscount.miles);
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_updateMiles = function (manualUserChange) {
        return __awaiter(this, void 0, void 0, function () {
            var sliderValue, flightDiscount, isMilesDiscountInValid, newArray, steps, selectedStep;
            var _this = this;
            return __generator(this, function (_a) {
                this.store.dispatch(new AncillariesWithMilesActions.PutLoadingAction(true)); // turn on loader
                sliderValue = parseFloat(this.formRange.controls['sliderControl'].value);
                flightDiscount = this.availableSteps.find(function (step) { return step.value === sliderValue; });
                isMilesDiscountInValid = (!this.hasLogin || !this.isUserMGPClient) && +flightDiscount.discount > 0;
                // call api to store flight miles spent
                if (flightDiscount && !isMilesDiscountInValid) { // && (this.milesService.oldMilesValue !== sliderValue)
                    try {
                        this.milesService.INDRA_updateMiles(+flightDiscount.discount).subscribe(function (data) {
                            if (data.errors.length == 0) {
                                _this.previousSliderValue = sliderValue;
                                _this.milesService.oldMilesValue = sliderValue;
                                _this.formRange.controls['sliderControl'].setValue(sliderValue);
                            }
                            else {
                                if (data.errors.filter(function (error) { return error.code == '400'; }).length) {
                                    sliderValue = 0;
                                    _this.formRange.controls['sliderControl'].setValue(sliderValue);
                                    _this.previousSliderValue = sliderValue;
                                    _this.milesService.oldMilesValue = sliderValue;
                                    flightDiscount.discount = 0;
                                    flightDiscount.value = 0;
                                }
                            }
                            _this.INDRA_triggerBookingTotalsUpdate(manualUserChange);
                            _this.INDRA_triggerCheckPaymentMethods();
                        });
                    }
                    catch (error) {
                        this.INDRA_triggerBookingTotalsUpdate(manualUserChange);
                        this.INDRA_triggerCheckPaymentMethods();
                        // reset sliderControl and flight discount to previous value to prevent checksum errors 
                        // (ie since api failed on the backend, it is assumed that the backend still has the previous miles discount value set
                        // thus frontend must also keep the previous miles discount value instead of the current/new one)
                        this.formRange.controls['sliderControl'].setValue(this.previousSliderValue);
                        flightDiscount = this.availableSteps.find(function (step) { return step.value === _this.previousSliderValue; });
                    }
                }
                if (flightDiscount) {
                    this.store.dispatch(new AncillariesWithMilesActions.PutFlightMilesDiscountAction({ cash: flightDiscount.discount, miles: flightDiscount.value }));
                    // apply / reapply mgp discount depending on miles selected by user
                    if (+flightDiscount.discount < this.promoMiles.discount || !this.promoMiles.value) {
                        if (this.bookedTripDiscounts.find(function (cur) { return cur.id == 'mile-go'; })) {
                            this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
                            this.store.dispatch(new MilesBarActions.SetDiscount(0));
                            newArray = this.bookedTripDiscounts.filter(function (discounts) { return discounts.id !== 'mile-go'; });
                            this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction(newArray));
                        }
                    }
                    else {
                        if (!this.bookedTripDiscounts.find(function (cur) { return cur.id == 'mile-go'; })) {
                            this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(true));
                            this.store.dispatch(new MilesBarActions.SetDiscount(this.promoMiles.discount));
                            this.bookedTripDiscounts.push({ id: 'mile-go', value: this.promoMiles.discount, label: 'Miles&go promo 400 miles' });
                            this.store.dispatch(new BookedTripActions.PutBookedTripDiscountsAction(this.bookedTripDiscounts));
                        }
                    }
                }
                // fix overlapping mgp logo
                if (this.hasPromo) {
                    steps = this.availableSteps.slice();
                    selectedStep = steps.find(function (step) { return step.value === _this.promoMiles.value; });
                    if (selectedStep)
                        sliderValue === this.promoMiles.value ? selectedStep.legend = '' : selectedStep.legend = '<div class="is-promo"></div>';
                    this.availableSteps = steps;
                }
                clearTimeout(this.loaderTimeout);
                this.loaderTimeout = setTimeout(function () {
                    _this.store.dispatch(new AncillariesWithMilesActions.PutLoadingAction(false)); // turn off loader
                }, 1500);
                return [2 /*return*/];
            });
        });
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_changeMiles = function (value) {
        this.formRange.controls['sliderControl'].setValue(value);
        this.INDRA_updateMiles(true);
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_getLeastStepMiles = function () {
        var nextStep = this.availableSteps.find(function (step) { return step.value > 0; });
        return nextStep ? nextStep.value : 0;
    };
    // ----------------------- END SLIDER PROCESSES -------------------------------//
    INDRAMilesSliderControlComponent.prototype.INDRA_handleLogin = function () {
        this.modalService.assignComponent(INDRALoginModalComponent);
        this.modalService.open();
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_handleNewAccount = function () {
        this.sidebarService.openSidebar(['sign-up']);
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_openUpgradeAccount = function () {
        this.sidebarService.openSidebar(['upgrade-miles-and-go'], [{ source: UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS }]);
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_triggerBookingTotalsUpdate = function (manualUserChange) {
        // only trigger booking total update when the user manually changed the slider or logs out while in review page
        if (manualUserChange && this.router.url.includes('review-your-trip')) {
            this.paymentInfoService.setUpdateBookingTotals(true);
        }
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_triggerCheckPaymentMethods = function () {
        // only trigger checkPaymentMethods when the user is in payment page
        if (this.router.url.includes('payment')) {
            this.paymentInfoService.setTriggerCheckPaymentMethods(true);
        }
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_isTesteSetMilesPoint = function () {
        return parseFloat(sessionStorage.getItem('teste-setMilesPoint')) === 1;
    };
    INDRAMilesSliderControlComponent.prototype.INDRA_setSliderControlToMax = function () {
        if (this.availableSteps && this.availableSteps.length) {
            this.formRange.controls['sliderControl'].setValue(this.availableSteps[this.availableSteps.length - 1].value);
        }
    };
    return INDRAMilesSliderControlComponent;
}(MilesSliderControlComponent));
export { INDRAMilesSliderControlComponent };
